//
//
//
//
//
//
//
//

export default {
  name: 'ImgCount',
  props: {
    total: {
      type: Number | String,
      default: 0,
    },
  },
  methods: {
    onClick(){
      this.$emit('on-click');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ImgCount.vue